import React from 'react';
import './Banner.css';
// Import the background image
import bannerBackground from '../../assets/banner-background.jpg';
// Import the logo image
import logo from '../../assets/jsw-logo.png';

const Banner: React.FC = () => {
  return (
    <section id="home" className="banner-section" style={{backgroundImage: `url(${bannerBackground})`}}>
      <div className="banner-overlay">
        <div className="banner-content">
          <img src={logo} alt="JSW Logo" className="logo-image" />
          <h1>
            <span>Jay Street Workout</span>{' '}
            <span>&amp;</span>{' '}
            <span>Calisthenics Studio</span>
          </h1>
          <h2>街頭及徒手健身</h2>
          <button className="cta-button" onClick={() => {
            window.location.href = 'https://wa.me/85261876217';
          }}>預約試堂</button>
        </div>
      </div>
    </section>
  );
};

export default Banner;
